module.exports = "<img src=/img/loader.gif /> ";